import React, { Component } from "react";
import {
  //   EmailValidate,
  FormValidate,
} from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import { user_event_payment_booking } from "../../../../../pages/user/user.api";
import "./dialog.css";
import TextField from "../../../../inputs/textfield";
import Snackbar from "../../../../snackbar/snackbar";
import Loader from "../../../../loader/loader";
import CommonForm from "../../../../commonform/commonForm";
import { DateObject } from "react-multi-date-picker";
import moment from "moment";
import { number } from "prop-types";

let required = [
  "reference_no",
  "paid_amount",
  "transaction_date",
  "mode",
  // "bank_details",
];
let required1 = [
  "reference_no",
  "paid_amount",
  "transaction_date",
  "mode",
  // "bank_details",
];

class PaymentDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: {},
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      emailError: false,
      isActive: false,
      isSnackError: false,
      snackOpen: false,
      event: props.event,
      currentYear: new Date().getFullYear(),
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
      event: props.event,
    });
  };
  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      const savedPaymentData = JSON.parse(
        localStorage.getItem("amount") || "null"
      );

      this.setState({
        open: this.props.open,
        edit: this.props.edit,
        formData: {
          ...this.props.formData,
          ...(savedPaymentData && !this.props.formData?.paid_amount
            ? { paid_amount: savedPaymentData }
            : {}),
        },
        event: this.props.event,
      });
    }
  }

  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split("T")[0];
  };
  handleSubmit = (e) => {
    const { emailError, event } = this.state;
    let reqType = event.paid === "0" ? required : required1;
    const errors = FormValidate(this.state.formData, reqType);

    const { edit, formData } = this.state;
    e.preventDefault();

    if (Object.keys(errors).length === 0) {
      let data = { ...formData };

      const [day, month, year] = data.transaction_date.split("-");
      data.transaction_date = `${year}-${month}-${day}`;

      data.event_id = this.state.event;
      data.utr_no = formData?.utr_no ?? "";

      this.setState({ isActive: true, submitted: true });

      const id = localStorage.getItem("booking_id");

      user_event_payment_booking(id, data)
        .then((res) => {
          this.setState({
            submitted: false,
            isActive: false,
            snackMessage: res.message,
            isSnackError: false,
            snackOpen: true,
          });
        })
        .catch((error) => {
          this.setState({
            submitted: false,
            isActive: false,
            snackMessage: error.message,
            isSnackError: true,
            snackOpen: true,
          });
        });
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  handleDatePickerChange = (e, name) => {
    let rawDate = e?.value;

    if (rawDate) {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: rawDate,
        },
      }));
    } else {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: "",
        },
      }));
    }
  };

  handlePhoneNumberChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    this.setState({ formData: { ...this.state.formData, [name]: newValue } });
  };

  render() {
    const {
      submitted,
      Message,
      isActive,
      isError,
      open,
      formData,
      event,
      currentYear,
    } = this.state;
    let sYearsAgo = new Date();
    sYearsAgo = sYearsAgo.setFullYear(sYearsAgo.getFullYear() - 1);
    const today = moment().format("YYYY-MM-DD");
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="big-dia-book">
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <Loader open={isActive} />
                <div className="row">
                  <div className="book-head">Payment Details</div>
                  <div className="dia-close" onClick={this?.props?.handleClose}>
                    <div className="diaCloseCon">
                      <div className="diaClose">&#10005;</div>
                    </div>
                  </div>
                  <div className="tilebar-book">
                    <hr />
                  </div>
                  <form action="">
                    <div className="book-form">
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Transaction Id"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          // value={formData.reference_no ?? ""}
                          value={(formData && formData.reference_no) || ""}
                          name="reference_no"
                          required
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Unique Transaction Reference (UTR No.)"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={(formData && formData.utr_no) || ""}
                          name="utr_no"
                        />
                      </div>
                      <div className="col-12">
                        <CommonForm
                          fieldType="date"
                          label={`Transaction Date `}
                          required
                          name="transaction_date"
                          minDate={sYearsAgo}
                          maxDate={today}
                          value={formData?.transaction_date ?? ""}
                          onChange={(e) => {
                            this.handleDatePickerChange(e, "transaction_date");
                          }}
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          type={"number"}
                          label="Amount"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={(formData && formData?.paid_amount) || ""}
                          name="paid_amount"
                          required
                          disabled
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Mode of Payment"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={(formData && formData.mode) || ""}
                          name="mode"
                          // maxLength="11"
                          required
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Name of Bank"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={(formData && formData.bank_details) || ""}
                          name="bank_details"
                          // maxLength="11"
                          // required
                        />
                      </div>

                      <div className="col-12">
                        <CustomButton
                          label="Submit"
                          disabled={submitted}
                          onClick={this.handleSubmit}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default PaymentDialog;
